import { CircularProgress } from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { toast } from 'react-toastify';
import { Footer, MenuBar } from '../../layout/welcome';
import { errorMessage } from '../../utils/notification';
import { settingContext } from '../../context/Setting/Setting';

const Index = () => {
    const [isLoading, setLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const [input, setInput] = React.useState({});
    const { page } = React.useContext(settingContext);
    const handleInputs = (label, e) => {
        var val = e.target.value;
        setInput({ ...input, [label]: val });
    };


    const retrieveInfo = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data, message } = await axios
                .post(process.env.REACT_APP_API_URL + "/course/verify/certificate", input, {
                    "Content-type": "application/json",
                });
            setData(data?.data);
            if (!data?.data?.id) {
                errorMessage(toast, 'No Information found for this reference');
            }
        } catch (error) {
            const err = error?.response?.data;
            errorMessage(toast, err?.message);
        }
        setLoading(false);
    }
    return (
        <div id="page-top" class="home">
            <div id="page-wrap">
                <MenuBar menuIndex="verify" setting={page?.setting}  />
                <section className="sub-banner sub-banner-course">
                    <div className="awe-static bg-sub-banner-course" style={{ backgroundImage: 'url(../img/course_banner.jpeg)' }} />
                    <div className="awe-overlay" />
                    <div className="container">
                        <div className="sub-banner-content">
                            <h1 className="text-center text-white font-bold text-5xl">Certificate Status Verification</h1>
                        </div>
                    </div>
                </section>
                <section className="course-top">
                    <div className="container">
                        <div className="flex justify-center w-100">
                            <p className="lead w-auto md:w-1/2 my-4">
                                Confirming the authenticity and validity of a certificate or document issued by Lakeshore. The purpose of certificate verification is to ensure that the certificate has not been altered or tampered with and that it was issued by the authorized body.
                            </p>
                        </div>

                        <div className="container my-4">
                            <div className="new-course  card-deck mb-3">
                                <div className="row ">
                                    <div className='col-md-3'></div>
                                    <div className="col-md-6">
                                        <form className='card p-4'>
                                            <div className="col-md-12">
                                                <h4 className='sm bold black'>Certificate Reference</h4>
                                                <input onChange={(e) => handleInputs("reference", e)} className="form-control" placeholder="Enter Certificate Reference"></input>
                                                <div className="my-5">
                                                    <button type="submit" onClick={retrieveInfo} className='btn btn-success'>
                                                        {!isLoading && `Verify`}
                                                        {isLoading && (
                                                            <div className="d-flex flex-row align-items-center">
                                                                <CircularProgress
                                                                    size={15}
                                                                    sx={{ color: "white", marginRight: 2 }}
                                                                />
                                                                <p>Connecting</p>
                                                            </div>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>

                                        </form>
                                        <div className="card p-3 my-2">
                                            <h4 className='sm bold black'>Reference Information</h4>
                                            <div className="col-md-12 table_responsive">
                                                {data?.id &&
                                                    <table className='table'>
                                                        <thead>
                                                            <tr>
                                                                <th>Issued to:</th>
                                                                <th>Date Issued:</th>
                                                                <th>Course:</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>{data?.user_detail?.first_name} {data?.user_detail?.last_name}</td>
                                                                <td>{moment(data?.created_at).format('LL')}</td>
                                                                <td>{data?.course?.title}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>}
                                                {!data?.id &&
                                                    <table className='table'>
                                                        <thead>
                                                            <tr>
                                                                <th>Issued to:</th>
                                                                <th>Date Issued:</th>
                                                                <th>Course:</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td className='col-span-3'>No Information found for this reference</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                }
                                            </div>
                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </div>
    );
};

export default Index;